import { render, staticRenderFns } from "./LeaderboardCompanysteps.vue?vue&type=template&id=1eddcbb9&scoped=true"
import script from "./LeaderboardCompanysteps.vue?vue&type=script&lang=js"
export * from "./LeaderboardCompanysteps.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardCompanysteps.vue?vue&type=style&index=0&id=1eddcbb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eddcbb9",
  null
  
)

export default component.exports